export default __webpack_public_path__ + "static/tree-692b99750b258aac87290c7478927682.webp";